"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelListSummary = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var __1 = require("..");
var FlexView_1 = require("../FlexView");
var Icon_1 = require("../Icon");
require("./panelListSummary.css");
var PanelListSummary = /** @class */ (function (_super) {
    __extends(PanelListSummary, _super);
    function PanelListSummary(props, state) {
        var _this = _super.call(this, props, state) || this;
        _this.renderAlert = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.alert), (0, Option_1.map)(function (alert) { return (0, jsx_runtime_1.jsx)("div", __assign({ className: "panel-list-summary-alert" }, { children: alert })); }), O.toNullable);
        };
        _this.onClickAccordion = function (slug) { return function () {
            return (0, function_1.pipe)(O.some(_this.state.accordionSlugOpen), O.filter(function (as) { return as.includes(slug); }), O.match(function () {
                return _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { accordionSlugOpen: __spreadArray(__spreadArray([], prevState.accordionSlugOpen, true), [slug], false) })); });
            }, function (as) {
                return _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { accordionSlugOpen: __spreadArray([], as.filter(function (c) { return c !== slug; }), true) })); });
            }));
        }; };
        _this.renderTitle = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.title), (0, Option_1.map)(function (title) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('panel-list-summary-title', "panel-list-summary-".concat(_this.props.type, "-title")) }, { children: [title.icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "xl", icon: title.icon }), (0, jsx_runtime_1.jsxs)("h4", { children: [" ", title.label] }), title.titleAction] }))); }), O.toNullable);
        };
        _this.renderActions = function () {
            return (0, function_1.pipe)(O.fromNullable(_this.props.actions), (0, Option_1.map)(function (actions) { return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView, __assign({ className: "panel-list-summary-footer", gutters: "xs" }, { children: actions.map(function (actionProps) {
                    var icon = actionProps.icon, onClick = actionProps.onClick, label = actionProps.label, slug = actionProps.slug, buttonStyle = actionProps.buttonStyle, buttonLoadable = actionProps.buttonLoadable;
                    var flexViewItemProps = actionProps.flexViewItemProps
                        ? __assign({}, actionProps.flexViewItemProps) : { xs: 12 };
                    return ((0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({}, flexViewItemProps, { className: buttonStyle ? '' : 'panel-list-summary-footer-item' }, { children: (0, jsx_runtime_1.jsx)(__1.Button, __assign({ icon: icon, onClick: onClick, styleType: buttonStyle ? buttonStyle : 'ghost-inverted', loadable: buttonLoadable, stretch: true }, { children: (0, jsx_runtime_1.jsx)("span", { children: label }) })) }), slug));
                }) }))); }), O.toNullable);
        };
        _this.state = {
            accordionSlugOpen: [],
        };
        return _this;
    }
    PanelListSummary.prototype.renderItems = function () {
        var _this = this;
        switch (this.props.type) {
            case 'list-checker':
                return (0, function_1.pipe)(O.fromNullable(this.props.items), (0, Option_1.map)(function (items) { return ((0, jsx_runtime_1.jsx)("ul", { children: items.map(function (item) { return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: (0, clsx_1.default)("item-value-color-".concat(item.color), !item.selected ? 'item-unselected' : null), onClick: function () { return item.onItemClick && item.onItemClick(item.slug); } }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "item-value" }, { children: item.title })), (0, jsx_runtime_1.jsx)("div", { className: item.icon })] }), item.slug)); }) })); }), O.toNullable);
            case 'plain':
                return (0, function_1.pipe)(O.fromNullable(this.props.items), (0, Option_1.map)(function (items) { return ((0, jsx_runtime_1.jsx)("ul", { children: items.map(function (item) { return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "item-title" }, { children: item.title })), (0, jsx_runtime_1.jsx)("div", { children: item.value })] }, item.slug)); }) })); }), O.toNullable);
            case 'accordion':
                return (0, function_1.pipe)(O.fromNullable(this.props.accordions), O.map(function (accordions) { return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: accordions.map(function (acc, index) {
                        var _a;
                        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "accordion-holder" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ onClick: _this.onClickAccordion(acc.slug), className: (0, clsx_1.default)('accordion-title', {
                                        open: _this.state.accordionSlugOpen.includes(acc.slug),
                                    }) }, { children: [(0, jsx_runtime_1.jsx)("h5", { children: acc.label }), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)((_a = {},
                                                _a['accordion-title-arrow'] = _this.state.accordionSlugOpen.includes(acc.slug),
                                                _a), { open: _this.state.accordionSlugOpen.includes(acc.slug) }) }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_arrow_down_dark", size: "std" }) }))] })), (0, jsx_runtime_1.jsx)("ul", __assign({ className: (0, clsx_1.default)('accordion-body', {
                                        open: _this.state.accordionSlugOpen.includes(acc.slug),
                                    }) }, { children: acc.items.map(function (item) { return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "accordion-item-title" }, { children: item.title })), (0, jsx_runtime_1.jsx)("div", { children: item.value })] }, item.slug)); }) }))] }), index));
                    }) })); }), O.toNullable);
        }
    };
    PanelListSummary.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('panel-list-summary', "panel-list-summary-".concat(this.props.type)) }, { children: [this.renderTitle(), this.renderAlert(), this.renderItems(), this.renderActions()] })));
    };
    return PanelListSummary;
}(React.PureComponent));
exports.PanelListSummary = PanelListSummary;
//# sourceMappingURL=PanelListSummary.js.map